module.exports={
    "urls": {
        "prod": "https://d1uznvntk80v7s.cloudfront.net/katal.assetloader.333c89ab194d.min.js",
        "prodmedia": "https://m.media-amazon.com/images/S/katalcomponents-assetbucket-1czezinnvs3jy/katal.assetloader.333c89ab194d.min.js",
        "prodchina": "https://images-cn.ssl-images-amazon.cn/images/S/katalcomponents-assetbucket-1czezinnvs3jy/katal.assetloader.333c89ab194d.min.js",
        "reactProd": "https://d1uznvntk80v7s.cloudfront.net/react-external-333c89ab194d/index.js",
        "webcomponentsLoader": "https://d1uznvntk80v7s.cloudfront.net/webcomponents/webcomponents-loader.2.8.0.js",
        "webcomponentsLoaderMedia": "https://m.media-amazon.com/images/S/katalcomponents-assetbucket-1czezinnvs3jy/webcomponents/webcomponents-loader.2.8.0.js",
        "webcomponentsLoaderChina": "https://images-cn.ssl-images-amazon.cn/images/S/katalcomponents-assetbucket-1czezinnvs3jy/webcomponents/webcomponents-loader.2.8.0.js",
        "prodWithDataGrid": "https://d1uznvntk80v7s.cloudfront.net/katal.assetloader-with-data-grid.333c89ab194d.min.js"
    },
    "domains": {
        "beta": "https://d1w4cdmlng3s1i.cloudfront.net/",
        "betamedia": "https://m.media-amazon.com/images/S/katalcomponents-assetbucket-xl8uijgxq8bh/",
        "betachina": "https://images-cn.ssl-images-amazon.cn/images/S/katalcomponents-assetbucket-xl8uijgxq8bh/",
        "prod": "https://d1uznvntk80v7s.cloudfront.net/",
        "prodmedia": "https://m.media-amazon.com/images/S/katalcomponents-assetbucket-1czezinnvs3jy/",
        "prodchina": "https://images-cn.ssl-images-amazon.cn/images/S/katalcomponents-assetbucket-1czezinnvs3jy/",
        "local": "./"
    },
    "themes": {
        "flo": {
            "stable": "katal.assetloader.333c89ab194d.min.js",
            "scoped": "katal.assetloader.333c89ab194d.min.js",
            "stableWithDataGrid": "katal.assetloader-with-data-grid.333c89ab194d.min.js"
        },
        "flow": {
            "stable": "katal.assetloader.333c89ab194d.min.js",
            "scoped": "katal.assetloader.333c89ab194d.min.js",
            "stableWithDataGrid": "katal.assetloader-with-data-grid.333c89ab194d.min.js"
        }
    }
};